const customIcons = {
  gas_pump: true,
  gas_station: true,
  pv: true,
  pv_farm: true,
  battery: true,
  energy_storage_system: true,
  genset: true,
  elec_pump: true,
  inverter: true,
  charger: true,
  combiner_box: true,
  weather_station: true,
  load_01: true,
  load_02: true,
  hvac: true,
  grid: true,
  genset_controler: true,
  wind_turbine: true,
  wind_farm: true,
  source: true,
  mesure: true,
  dashboard: true,
  flow: true,
  chart: true,
  histo: true,
  points: true,
  load_03: true,
  energy_efficiency: true,
  configuration: true
};

const icons = {
  customIcons
};

export default icons;
